import {apiRedemption} from "../clients";

export const AddInCampaign = async (User, finallyCallback = () => { }, { callback }) => {
    const campaignCatalog = {
        campaignId: User.profile['custom:campaign_id'] == '50634' ? '71171' : '71292',
        catalogId: User.profile['custom:campaign_id'] == '50634' ? '81222' : '81338',
    }

    apiRedemption(User).post(`Participant/AddInCampaign`, campaignCatalog).then((response) => {
        if (callback) {
            callback({ error: null, data: response.data });
        }
    }).catch((e) => {
        if (callback) {
            callback({ error: e, data: null });
        }
    }).finally(() => {
        finallyCallback();
    });
};
